// const API_KEY = "896c8566fc255f7c52f6ea6bd2901188";

const requests = {
    fetchDQsPick: `/all`,
    fetchActionMovies: `/genres/action`,
    fetchComedyMovies: `/genres/comedy`,
    fetchHorrorMovies: `/genres/horror`,
    fetchRomanceMovies: `/genres/romance`,
}

export default requests;